import { render, staticRenderFns } from "./custom-audit-detail.vue?vue&type=template&id=0a200220&"
import script from "./custom-audit-detail.vue?vue&type=script&lang=js&"
export * from "./custom-audit-detail.vue?vue&type=script&lang=js&"
import style0 from "./custom-audit-detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports